import { lazy, useState } from 'react'

import { SuspenseWrapper } from '@/components/Suspense/SuspenseWrapper'
import useParamSelector from '@/hooks/useParamSelector'
import {
  canBuyProduct,
  getProductDesignation,
  hasCard,
} from '@/store/selectors'

import PurchaseModal from './PurchaseModal'
import RequestBuyModal from './RequestBuyModal'

const NoCreditCardModal = lazy(() => import('./NoCreditCardModal'))

type Props = {
  id: string
}

export const PaymentModal = ({ id }: Props) => {
  const designation = useParamSelector(getProductDesignation, id)
  const canBuy = useParamSelector(canBuyProduct, designation)
  const hasCreditCard = useParamSelector(hasCard, designation)
  const [initialHasCreditCard] = useState(hasCreditCard)

  if (!canBuy) {
    return <RequestBuyModal />
  }

  if (!initialHasCreditCard) {
    return (
      <SuspenseWrapper>
        <NoCreditCardModal />
      </SuspenseWrapper>
    )
  }

  return <PurchaseModal />
}

export default PaymentModal
